import React from "react";
import {
    Container,
    Row, 
    Col,
} from "react-bootstrap";
import ReactGA from 'react-ga';

export default function PatientAcquasition (){
    ReactGA.pageview(window.location.pathname + window.location.search);    
    return (

        <Container className='mt-5 mb-5'>
                        <h1 className='text-center'>The only risk-free patient acquisition solution for dentists.</h1>
        <Row xs={1} md={3} lg={3} > 
        <Col className="mt-5 mb-5" >
            <h4>High-quality patients</h4>
            <h5>We match high quality patients that are well-suited to your practice, while decreasing cancellation and no-show rates.</h5>
        </Col>
        <Col className="mt-5 mb-5" >
            <h4>Guaranteed results</h4>
            <h5>We remove all the risks associated with marketing. Unlike other solutions, with Opencare you only pay when you actually see patients.</h5>
        </Col>
        <Col className="mt-5 mb-5" >
            <h4>Managed for you</h4>
            <h5>We take care of everything when it comes to growing your practice so you can focus on delivering exceptional patient experiences.</h5>
        </Col>
        </Row>
        </Container>
    )
}


